import React, { useEffect, useState } from "react";
import {
  TODAYS_FOLLOWUP_LIST_DATA,
  TODAYS_FOLLOWUP_LIST_HEADERS,
  TODAYS_FOLLOWUP_LIST_KEY_MAPPING,
} from "../../../../constants/TodaysFollowUpList";
import searchIcon from "./../../../../Assets/icons/searchicon.svg";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import ReusableTable from "../PresalesTable";
import axiosInstance from "../../../services/api/API";
import ROUTES_NAVIGATION from "../../../../routes/routes";
import TotalCounts from "../TotalCounts";
import { IoMdClose } from "react-icons/io";
import ListLogisticsFilters from "../../Logistics/LogisticsFilter";

const TodaysFollowUps = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [makeData, setMakeData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);

  const [filterFormData, setFilterFormData] = useState({});
  const [validationErrors, setValidationErrors] = useState({});

  const [filters, setFilters] = useState({
    product: "",
    make: "",
    model: "",
    fromDate: "",
    toDate: "",
  });
  const [make, setMake] = useState([]);
  const [model, setModel] = useState([]);
  const [product, setProduct] = useState([]);
  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");
  const businessPartnerId = localStorage.getItem("businessPartnerId");
  const [graphData, setGraphData] = useState({
    Organic: [],
    SocialMedia: [],
    FromAdds: [],
    Other: [],
    month: [],
  });

  // useEffect(() => {
  //   fetchGraphData();
  // }, []);

  // const fetchGraphData = async () => {
  //   try {
  //     const business_partner_id = 1;
  //     const response = await axiosInstance.post(
  //       "/presale/listgraph",
  //       {
  //         business_partner_id,
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );

  //     const fetchedData = response.data.data.leadbargraph;

  //     setGraphData({
  //       Organic: fetchedData.Organic,
  //       SocialMedia: fetchedData.SocialMedia,
  //       FromAdds: fetchedData.FromAdds,
  //       Other: fetchedData.Other,
  //       month: fetchedData.month,
  //     });
  //   } catch (error) {
  //     console.error(error, "error");
  //   }
  // };

  const handleSearchInputChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleFilterChange = (event) => {
    const { name, value } = event.target;
    setFilters({ ...filters, [name]: value });
  };

  // const handleApplyFilters = (filteredData) => {
  //   fetchTodaysFollowUpFilterList(filteredData)
  // }

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchTodaysFollowUpList(newPage);
  };

  const handleResetFilters = () => {
    setFilters({
      product: "",
      make: "",
      model: "",
      fromDate: "",
      toDate: "",
    });
    // Add logic to reset filters and update the table data
  };

  const data = {
    months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"],
    organicLeads: [15, 20, 30, 40, 25, 30, 20],
    socialMediaLeads: [10, 15, 25, 35, 20, 25, 15],
    adsLeads: [5, 10, 15, 20, 10, 15, 10],
    otherLeads: [3, 5, 8, 12, 6, 8, 5],
  };

  const productOptions = ["Product1", "Product2", "Product3"];
  const makeOptions = ["Make1", "Make2", "Make3"];
  const modelOptions = ["Model1", "Model2", "Model3"];

  const formatDataForDownload = (data, headers, keyMapping) => {
    const csvHeaders = headers.map((header) => keyMapping[header]);
    const csvRows = data.map((item) => {
      return headers
        .map((header) => {
          const key = keyMapping[header];
          return item[key];
        })
        .join(",");
    });
    const csvContent = [csvHeaders.join(","), ...csvRows].join("\n");
    return csvContent;
  };

  const handleSearchKeyPress = (event) => {
    if (event.key === "Enter") {
      fetchTodaysFollowUpList({ searchText: searchTerm });
    }
  };

  const clearSearchAndFetch = () => {
    setSearchTerm("");
  };
  useEffect(() => {
    if (searchTerm === "") {
      fetchTodaysFollowUpList({ searchText: "" });
    }
  }, [searchTerm]);

  const fetchTodaysFollowUpList = async (page = 0, pageSize = 10) => {
    const allfilteredData = filters;
    try {
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString(); // Format the date to ISO string

      const response = await axiosInstance.post(
        "/today-followup/list",
        {
          page,
          orderBy: "lead_customer_id desc",

          pageSize,
          action_tobe_taken_datetime: formattedDate,
          startDate: allfilteredData?.fromDate
            ? allfilteredData?.fromDate
            : null,
          endDate: allfilteredData?.toDate ? allfilteredData?.toDate : null,
          make_id: allfilteredData?.make ? allfilteredData?.make : null,
          model_id: allfilteredData?.model ? allfilteredData?.model : null,
          product_id: allfilteredData?.product
            ? allfilteredData?.product
            : null,
          searchText: searchTerm || "",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          // timeout: 10000,
        }
      );

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        "Sr No.": index + 1,
      }));

      const totalRecordsData = response?.data?.data?.totalRecords;
      console.log(totalRecordsData, "RECORDS");
      setTotalRecords(totalRecordsData);

      setMakeData(formattedData);
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error("Error fetching make list:", error);
    }
  };

  // const filteredData = makeData.filter((item) =>
  //   item.first_name.toLowerCase().includes(searchTerm.toLowerCase())
  // );

  const handleDownloadClick = () => {
    const csvContent = formatDataForDownload(
      TODAYS_FOLLOWUP_LIST_DATA,
      TODAYS_FOLLOWUP_LIST_HEADERS,
      TODAYS_FOLLOWUP_LIST_KEY_MAPPING
    );
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "business_partner_data.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleEdit = (rowData) => {
    console.log("rowdata>", rowData);
    navigate("/admin/manage-dealer/business-partner/add-business-partner", {
      state: { rowData },
    });
  };
  useEffect(() => {
    fetchTodaysFollowUpList();
  }, []);

  useEffect(() => {
    // fetchProductDD()
    fetchProductOptions();
  }, []);

  const fetchProductOptions = async () => {
    try {
      const response = await axiosInstance.post(
        "/product/list",
        {
          orderBy: "product_id desc",
          page: 0,
          pageSize: 100, // Adjust as needed
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const options = response.data.data.data.map((product) => ({
        label: product.product_name,
        value: product.product_id,
      }));

      setProduct(options);
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };

  useEffect(() => {
    const productId = filterFormData.product_id;
    if (productId) {
      fetchMakeDD(productId);
      setMake([]);
    }
  }, [filterFormData.product_id]);

  useEffect(() => {
    const makeId = filterFormData.make_id;
    const productId = filterFormData.product_id;

    if (productId && makeId) {
      fetchModelDD(makeId, productId);

      setModel([]);
    }
  }, [filterFormData.make_id, filterFormData.product_id]);

  const fetchMakeDD = async (productId) => {
    try {
      const business_partner_id = 1;
      const response = await axiosInstance.post(
        "/make/ddlmake",
        {
          business_partner_id,
          product_id: productId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const fetchedData = response.data.data.data;
      const makedata = fetchedData.map((dropdown) => ({
        value: dropdown.ID,
        label: dropdown.NAME,
      }));
      setMake(makedata);
    } catch (error) {
      console.log(error, "error");
    }
  };

  const fetchModelDD = async (makeId, productId) => {
    try {
      const business_partner_id = 1;

      const response = await axiosInstance.post(
        "/model/ddlmodel",
        {
          business_partner_id,
          product_id: productId,
          make_id: makeId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const fetchedData = response.data.data.data;
      const modeldata = fetchedData.map((dropdown) => ({
        value: dropdown.ID,
        label: dropdown.NAME,
      }));
      setModel(modeldata);
    } catch (error) {
      console.log(error, "error");
    }
  };

  console.log("graphDatamain>>", graphData);

  const handleViewButton = (rowData) => {
    console.log("rowdata>", rowData);
    navigate(`${ROUTES_NAVIGATION.FOLLOWUPREQUIREDDETAILS}`, {
      state: { data: rowData },
    });
  };

  const clearFilter = () => {
    setFilterFormData({});
    setFilters({});
    fetchTodaysFollowUpList(0, 10);
  };

  const handleSearch = () => {
    // Update the filters state with the current form data
    setFilters({
      fromDate: filterFormData.startDate || null,
      toDate: filterFormData.endDate || null,
      make: filterFormData.make_id || null,
      model: filterFormData.model_id || null,
      product: filterFormData.product_id || null,
    });

    fetchTodaysFollowUpList(0, 10);
    // fetchFollowUpRequireeList(0, 10);
  };

  // const handleSearch = (filterData) => {
  //   setFilters(filterData);
  //   fetchTodaysFollowUpFilterList(filterData);
  // };

  useEffect(() => {
    fetchTodaysFollowUpList();
  }, [filters]);

  const PhysicalStockTakingInputs = [
    {
      name: "startDate",
      label: "From Date",
      type: "date",
      maxDate: new Date(),
      required: true,
      gridClass: "col-lg-2",
    },
    {
      name: "endDate",
      label: "To Date",
      type: "date",
      maxDate: new Date(),
      required: true,
      gridClass: "col-lg-2",
    },
    {
      name: "product_id",
      label: "Product",
      placeholder: "Select City",
      type: "dropdown",
      options: product,
      required: true,
      gridClass: "col-lg-2",
    },
    {
      name: "make_id",
      label: "Make",
      placeholder: "Select City",
      type: "dropdown",
      options: make,
      required: true,
      gridClass: "col-lg-2",
    },
    {
      name: "model_id",
      label: "Model",
      placeholder: "Select City",
      type: "dropdown",
      options: model,
      required: true,
      gridClass: "col-lg-2",
    },
  ];

  return (
    <div>
      <div className="OnboardManagamentContainer row">
        <TotalCounts title={"FollowUps"} subtitle={"Home/Presales"} />
      </div>

      <div>{/* <LeadsDashboard graphData={graphData} /> */}</div>

      <div className="tableWrapper">
        <div className="listsearchContainerr">
          <h5>Today's FollowUp List</h5>
          <div className="searchinput-wrapper">
            <input
              type="text"
              className="searchinput"
              placeholder="Search.."
              value={searchTerm}
              onChange={handleSearchInputChange}
              onKeyDown={handleSearchKeyPress}
            />
            {searchTerm ? (
              <IoMdClose
                size={22}
                className="searchinput-close-icon"
                onClick={clearSearchAndFetch}
              />
            ) : (
              <img src={searchIcon} alt="Search" className="searchinput-icon" />
            )}
          </div>
        </div>
        <div className="admin-list-containerr">
          <div style={{ display: "flex" }} className="filterWrapper">
            <p
              style={{
                paddingRight: "8px",
                marginTop: "75px",
                marginLeft: "14px",
              }}
            >
              Filter By
            </p>
            {/* <ListPreSalesFilters productdd={productdd} setProductdd={setProductdd} makedd={makedd} setMakedd={setMakedd} model={model} product={product} make={make} clearSearch={clearFilter} handleSearch={handleSearch} isPresales={true} /> */}
            <ListLogisticsFilters
              formConfig={PhysicalStockTakingInputs}
              formData={filterFormData}
              setFormData={setFilterFormData}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
              handleSearch={handleSearch}
              handleClear={clearFilter}
              // onSubmit={handleFormSubmit}
            />
          </div>
        </div>

        <ReusableTable
          data={makeData}
          headers={TODAYS_FOLLOWUP_LIST_HEADERS}
          keyMapping={TODAYS_FOLLOWUP_LIST_KEY_MAPPING}
          itemsPerPage={10}
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          onEdit={handleEdit}
          isFollowUp={true}
          handleViewButton={handleViewButton}
          totalRecords={totalRecords}
          callListApi={fetchTodaysFollowUpList}
          

        />
      </div>
    </div>
  );
};

export default TodaysFollowUps;
